import Loadable from '../../components/loadable';

const AttendanceNotesReport = Loadable({
  loader: () => import('../../pages/reports/attendance_notes_report/attendance_notes_report'),
});

angular.module('gym').value('AttendanceNotesReport', AttendanceNotesReport);

const AttendanceNotesReportFiltersModal = Loadable({
  loader: () =>
    import('../../pages/reports/attendance_notes_report/attendance_notes_report_filters_modal'),
});

angular.module('gym').value('AttendanceNotesReportFiltersModal', AttendanceNotesReportFiltersModal);
